import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ProcessFlowchartEditorConfigurator, WorkflowFeature} from './ProcessFlowchartEditorConfigurator';

export interface DefaultTransitionModalConfiguratorOptions {}

/**
 * Default transition modal configurator
 */
export class DefaultTransitionModalConfigurator extends ProcessFlowchartEditorConfigurator<DefaultTransitionModalConfiguratorOptions> {
  allowedNodeExecutionTypes(): Array<ProcessExecutionType> {
    return [ProcessExecutionType.DIRECT, ProcessExecutionType.ENTRY];
  }

  enabledWorkflowsFeatures(): Array<WorkflowFeature> {
    return [WorkflowFeature.CUSTOMIZE_TRANSITION_SOURCE];
  }
}
